<template>
  <div>
    <SiteHeader />
    <WaBtn />
    <!-- main banner -->
    <div>
      <div>
        <div class="hidden md:block">
          <div class="flex flex-wrap justify-center">
            <div class="w-1/2 py-5 bg-red-custom">
              <div class="m-auto lg:w-4/5">
                <div
                  class="px-4 pt-40 text-4xl font-bold leading-tight text-center text-white lg:text-5xl"
                >
                  <h1>Looking For a Bed Bug Treatment That Works?</h1>
                </div>
                <div class="px-4 pt-4 text-lg leading-tight text-center text-white lg:text-xl">
                  <h2>
                    Our Pest Control Professionals are
                    <br />
                    <b>EXPERIENCE, TRAINED, ATTENTIVE, and RESPONSIBLE</b>
                  </h2>
                </div>
              </div>
            </div>
            <div id="get-a-free-quote-now"
              class="w-1/2 bg-center bg-cover"
              style="background-image: url('/images/banner.jpg');"
            >
              <div
                class="w-3/4 px-5 pt-4 m-auto my-8 font-bold text-center text-white lg:w-2/3 bg-red-custom"
              >
                <span class="text-lg">Same Day Call Back</span>
                <h3 class="text-4xl">Enquire Today!</h3>
                <iframe
                  allowtransparency="true"
                  width="100%"
                  id="contactform123"
                  name="contactform123"
                  marginwidth="0"
                  marginheight="0"
                  frameborder="0"
                  src="//feedback.activamedia.com.sg/my-contact-form-5408586.html"
                  style="min-height: 520px; height: inherit; overflow: auto;"
                ></iframe>
              </div>
            </div>
          </div>
        </div>

        <div id="get-a-free-quote-now" class="block md:hidden">
          <div class="py-5 bg-red-custom">
            <div class="m-auto sm:w-3/4">
              <div class="px-4 text-3xl font-bold leading-tight text-center text-white sm:text-4xl">
                <h1>Looking For a Bed Bug Treatment That Works?</h1>
              </div>
              <div class="px-4 pt-4 text-lg leading-tight text-center text-white">
                <h2>
                  Our Pest Control Professionals are
                  <br />
                  <b>EXPERIENCE, TRAINED, ATTENTIVE, and RESPONSIBLE</b>
                </h2>
              </div>
            </div>
          </div>
          <div>
            <img src="/images/banner.jpg" alt="Background Images" />
          </div>
        </div>
      </div>
    </div>
    <!-- end main banner -->

    <!-- mobile-form -->
    <div id="get-a-free-quote-now" class="container pt-4 m-auto font-bold text-center md:hidden">
      <span class="text-lg">Same Day Call Back</span>
      <h3 class="text-4xl">Enquire Today!</h3>
      <iframe
        allowtransparency="true"
        width="100%"
        id="contactform123"
        name="contactform123"
        marginwidth="0"
        marginheight="0"
        frameborder="0"
        src="//feedback.activamedia.com.sg/my-contact-form-5408586.html"
        style="min-height: 520px; height: inherit; overflow: auto;"
      ></iframe>
    </div>
    <!-- end mobile-form -->

    <!-- Product -->
    <div class="bg-black">
      <div class="container py-10">
        <h1 class="text-2xl font-bold text-center text-white lg:text-3xl">Are You Facing These?</h1>
        <div class="pt-8 md:flex md:flex-wrap">
          <div class="py-2 md:w-1/3 md:px-2">
            <div class="bg-white">
              <div class="float-right w-1/2 py-2 text-2xl font-semibold bg-red-custom">
                <h1 class="text-center text-white">Alert 1</h1>
              </div>
              <div class="clearfix"></div>
              <div class="px-4 py-8 text-center md:h-40">
                <p
                  class="text-lg"
                >Itchy rashes on your arms, legs, or back, when you wake up in the morning</p>
              </div>
            </div>
          </div>
          <div class="py-2 md:w-1/3 md:px-2">
            <div class="bg-white">
              <div class="float-right w-1/2 py-2 pr-2 text-2xl font-semibold bg-red-custom">
                <h1 class="text-center text-white">Alert 2</h1>
              </div>
              <div class="clearfix"></div>
              <div class="px-4 py-8 text-center md:h-40">
                <p class="text-lg">Blood stains at the seams of your mattress</p>
              </div>
            </div>
          </div>
          <div class="py-2 md:w-1/3 md:px-2">
            <div class="bg-white">
              <div class="float-right w-1/2 py-2 pr-2 text-2xl font-semibold bg-red-custom">
                <h1 class="text-center text-white">Alert 3</h1>
              </div>
              <div class="clearfix"></div>
              <div class="px-4 py-8 text-center md:h-40">
                <p class="text-lg">Musty smell in your room</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end Product -->

    <!-- services -->
    <div id="bed-bugs-control" class="py-10 bg-red-custom">
      <div class="container">
        <div class="max-w-sm mx-auto md:max-w-full">
          <div class="pb-5 text-white">
            <div class="pb-5 text-center">
              <h1 class="text-xl xl:text-2xl">Our</h1>
              <h1 class="pb-3 text-2xl font-bold md:text-2xl lg:text-3xl">Commitment</h1>
              <p
                class
              >We believe in thoroughly understanding your bed bug issue and provide the most suitable solution / treatment to resolve the issue. Be it a recurring or a first-time bed bug issue we are experienced to resolve them effectively!</p>
            </div>
            <div class="md:flex md:flex-wrap lg:justify-center">
              <div v-for="(item, i) in choose" :key="i" class="flex py-3 md:w-1/2 lg:w-1/3 xl:1/4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="flex-none w-8 h-8 text-yellow-500 fill-current"
                  viewBox="0 0 100 100"
                >
                  <path
                    d="M74.969 33.562a4.052 4.052 0 00-5.73-.151L43.357 57.955 31.012 45.281a4.053 4.053 0 10-5.808 5.656l15.135 15.539a4.055 4.055 0 005.695.115l28.784-27.297a4.055 4.055 0 00.151-5.732z"
                  />
                  <path
                    d="M50 0C22.43 0 0 22.43 0 50s22.43 50 50 50 50-22.43 50-50S77.57 0 50 0zm0 91.893C26.901 91.893 8.108 73.1 8.108 50 8.108 26.901 26.901 8.108 50 8.108c23.1 0 41.893 18.793 41.893 41.892C91.893 73.1 73.1 91.893 50 91.893z"
                  />
                </svg>
                <div class="px-3">
                  <p class="text-md">{{item.p}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="md:hidden">
      <img src="/images/360-img.jpg" alt="bed bug" class="w-full" />
    </div>
    <div class="hidden md:block">
      <img src="/images/1024-img.jpg" alt="bed bug" class="w-full" />
    </div>
    <!-- end services -->
    <!-- why choose us -->
    <div class="py-8 text-white bg-black">
      <div class="container">
        <div class="xl:flex xl:flex-wrap">
          <div class="xl:w-1/2 xl:pt-8">
            <div class="pb-8">
              <h1
                class="text-xl font-bold text-center md:text-2xl lg:text-3xl color-custom"
              >#1 Bed Bug Specialist in Singapore</h1>
            </div>
            <div class="w-full text-center">
              <p>
                With over 10 years of experience, we understand our clients’ urgency and frustration to their pest issue(s) when they reach out to us. We are committed to be <b>responsive, dedicated, efficient, and prompt</b> to your issues. 
              </p>
              <br />
              <p>
                With our trained and experience team always on standby. We have the required knowledge to provide <b>quality and reliable</b> to all pet issues at all times. Trust us in resolving your pest problems through a <b>safe, effective, and affordable</b> manner.
              </p>
            </div>
          </div>
          <div class="xl:w-1/2">
            <div class="flex flex-wrap md:justify-center">
              <div class="w-1/2 py-4 md:w-1/4 xl:w-1/2">
                <svg
                  class="block w-24 h-24 mx-auto fill-current color-custom"
                  viewBox="0 0 100 100"
                >
                  <path
                    d="M23.333 68.334a5 5 0 100 10 5 5 0 000-10zm0 6.666a1.667 1.667 0 110-3.334 1.667 1.667 0 010 3.334zM76.666 68.334a5 5 0 100 10 5 5 0 000-10zm0 6.666a1.666 1.666 0 110-3.332 1.666 1.666 0 010 3.332z"
                  />
                  <path
                    d="M98.729 44.609L87.248 31.68A4.998 4.998 0 0083.5 30H68.334V20a5.006 5.006 0 00-5-5H5a5.006 5.006 0 00-5 5v43.334A1.666 1.666 0 001.667 65h1.667v5a5.006 5.006 0 005 5H11.8a11.651 11.651 0 0023.068 0h30.266a11.652 11.652 0 0023.068 0H95a5.006 5.006 0 005-5V47.933a4.993 4.993 0 00-1.271-3.324zM3.333 61.666V20A1.67 1.67 0 015 18.333h58.334c.92.001 1.665.747 1.666 1.667v41.666H3.333zm8.467 10H8.333c-.92 0-1.666-.746-1.667-1.666v-5h8.518a11.64 11.64 0 00-3.384 6.666zm11.533 10c-4.603 0-8.333-3.73-8.333-8.333S18.731 65 23.333 65a8.333 8.333 0 018.333 8.334 8.34 8.34 0 01-8.333 8.332zm16.667-10h-5.133A11.634 11.634 0 0031.483 65H40v6.666zm15 0H43.333V65H55v6.666zm10.133 0h-6.799V65h10.184a11.635 11.635 0 00-3.385 6.666zm11.533 10c-4.602 0-8.333-3.73-8.333-8.333S72.064 65 76.666 65A8.332 8.332 0 0185 73.333a8.342 8.342 0 01-8.334 8.333zm20-11.666c0 .92-.746 1.666-1.666 1.666h-6.8a11.676 11.676 0 00-11.534-10h-8.333V33.333H75V50a5.006 5.006 0 005 5h16.666v15zm0-18.334H80c-.92 0-1.666-.746-1.666-1.666V33.333H83.5c.479-.003.936.2 1.254.557l11.485 12.935c.273.305.426.699.428 1.108l-.001 3.733z"
                  />
                </svg>
                <h1 class="py-3 font-semibold text-center lg:text-xl">Respond within 6 hours</h1>
              </div>

              <div class="w-1/2 py-4 md:w-1/4 xl:w-1/2">
                <svg
                  class="block w-24 h-24 mx-auto fill-current color-custom"
                  viewBox="0 0 100 100"
                >
                  <path
                    d="M80.826 19.459h-6.998v-2.055c0-2.429-1.976-4.404-4.404-4.404s-4.404 1.976-4.404 4.404v2.055H40.355v-2.055c0-2.429-1.976-4.404-4.404-4.404s-4.404 1.976-4.404 4.404v2.11a1.443 1.443 0 00-.391-.055h-5.85c-4.048 0-7.341 3.293-7.341 7.341v25.006a1.468 1.468 0 002.936 0V34.581h52.926a1.468 1.468 0 100-2.936H20.902V26.8a4.409 4.409 0 014.404-4.404h5.85c.136 0 .267-.02.391-.054v1.889c0 2.429 1.976 4.404 4.404 4.404s4.404-1.976 4.404-4.404v-1.835H65.02v1.835c0 2.429 1.976 4.404 4.404 4.404s4.404-1.976 4.404-4.404v-1.835h6.998A4.409 4.409 0 0185.23 26.8v55.788a2.646 2.646 0 01-2.643 2.643 2.647 2.647 0 01-2.644-2.643v-3.799c0-.811-.658-1.468-1.469-1.468H61.398c-.811 0-1.467.657-1.467 1.468 0 .812.656 1.469 1.467 1.469h15.609v2.33c0 .955.241 1.856.667 2.643H18.579a2.646 2.646 0 01-2.643-2.643v-2.33h32.86c.812 0 1.468-.657 1.468-1.469 0-.811-.656-1.468-1.468-1.468H34.127a12.013 12.013 0 004.194-9.12c0-6.639-5.4-12.039-12.039-12.039-6.638 0-12.038 5.4-12.038 12.039 0 3.643 1.629 6.911 4.194 9.12h-3.971c-.811 0-1.468.657-1.468 1.468v3.799a5.586 5.586 0 005.579 5.579h64.009a5.586 5.586 0 005.579-5.579V26.8c.001-4.048-3.292-7.341-7.34-7.341zm-43.407 4.772a1.47 1.47 0 01-1.468 1.468 1.47 1.47 0 01-1.468-1.468v-6.827c0-.81.659-1.468 1.468-1.468.81 0 1.468.659 1.468 1.468v6.827zm33.473 0a1.468 1.468 0 01-2.936 0v-6.827a1.469 1.469 0 012.936 0v6.827zm-53.711 43.97c0-5.02 4.083-9.103 9.102-9.103s9.103 4.083 9.103 9.103-4.083 9.102-9.103 9.102-9.102-4.082-9.102-9.102z"
                  />
                  <path
                    d="M81.753 32.075c-.273-.273-.652-.43-1.038-.43s-.765.157-1.038.43c-.272.273-.43.652-.43 1.038s.157.765.43 1.038.652.43 1.038.43.765-.157 1.038-.43.43-.652.43-1.038a1.48 1.48 0 00-.43-1.038zM56.845 77.751a1.47 1.47 0 00-2.506 1.038c0 .388.157.765.431 1.039a1.47 1.47 0 002.506-1.039 1.485 1.485 0 00-.431-1.038zM46.215 57.631c-3.076 0-5.579 2.502-5.579 5.578s2.503 5.579 5.579 5.579c3.076 0 5.579-2.503 5.579-5.579s-2.503-5.578-5.579-5.578zm0 8.221c-1.457 0-2.643-1.186-2.643-2.643s1.186-2.643 2.643-2.643 2.643 1.186 2.643 2.643-1.186 2.643-2.643 2.643zM59.918 57.631c-3.076 0-5.579 2.502-5.579 5.578s2.503 5.579 5.579 5.579c3.075 0 5.578-2.503 5.578-5.579s-2.503-5.578-5.578-5.578zm0 8.221c-1.458 0-2.643-1.186-2.643-2.643s1.185-2.643 2.643-2.643c1.456 0 2.643 1.186 2.643 2.643s-1.187 2.643-2.643 2.643zM73.619 57.631c-3.075 0-5.578 2.502-5.578 5.578s2.503 5.579 5.578 5.579c3.077 0 5.579-2.503 5.579-5.579s-2.502-5.578-5.579-5.578zm0 8.221c-1.456 0-2.643-1.186-2.643-2.643s1.187-2.643 2.643-2.643c1.458 0 2.643 1.186 2.643 2.643s-1.185 2.643-2.643 2.643zM32.513 42.362a5.586 5.586 0 00-5.579 5.579 5.585 5.585 0 005.579 5.578 5.585 5.585 0 005.579-5.578 5.586 5.586 0 00-5.579-5.579zm0 8.222c-1.458 0-2.643-1.186-2.643-2.643s1.185-2.643 2.643-2.643c1.457 0 2.643 1.186 2.643 2.643s-1.186 2.643-2.643 2.643zM59.918 42.362a5.586 5.586 0 00-5.579 5.579 5.585 5.585 0 005.579 5.578 5.585 5.585 0 005.578-5.578 5.585 5.585 0 00-5.578-5.579zm0 8.222c-1.458 0-2.643-1.186-2.643-2.643s1.185-2.643 2.643-2.643c1.456 0 2.643 1.186 2.643 2.643s-1.187 2.643-2.643 2.643zM73.619 42.362a5.585 5.585 0 00-5.578 5.579 5.585 5.585 0 005.578 5.578 5.585 5.585 0 005.579-5.578 5.585 5.585 0 00-5.579-5.579zm0 8.222c-1.456 0-2.643-1.186-2.643-2.643s1.187-2.643 2.643-2.643c1.458 0 2.643 1.186 2.643 2.643s-1.185 2.643-2.643 2.643zM46.215 42.362a5.586 5.586 0 00-5.579 5.579 5.585 5.585 0 005.579 5.578 5.585 5.585 0 005.579-5.578 5.586 5.586 0 00-5.579-5.579zm0 8.222c-1.457 0-2.643-1.186-2.643-2.643s1.186-2.643 2.643-2.643 2.643 1.186 2.643 2.643-1.186 2.643-2.643 2.643zM31.514 64.623a1.47 1.47 0 00-2.077 0l-4.781 4.781-1.634-1.634a1.468 1.468 0 00-2.076 2.076l2.672 2.672a1.468 1.468 0 002.076 0l5.82-5.819a1.468 1.468 0 000-2.076z"
                  />
                </svg>
                <h1 class="py-3 font-semibold text-center lg:text-xl">10 years of Experience</h1>
              </div>
              <div class="w-1/2 py-4 md:w-1/4 xl:w-1/2">
                <svg
                  class="block w-24 h-24 mx-auto fill-current color-custom"
                  viewBox="0 0 100 100"
                >
                  <path
                    d="M26.76 87.262l-2.405-3.388a1.598 1.598 0 00-2.605 1.85l2.405 3.388a1.598 1.598 0 102.605-1.85zM45.188 87.858l-2.617-12.473a23.52 23.52 0 00-9.948-14.77l-5.587-3.757a5.622 5.622 0 00-7.125.727V38.34a5.315 5.315 0 00-4.189-5.22 5.32 5.32 0 00-4.505 1.049 5.323 5.323 0 00-2 4.171v24.767c0 3.245.993 6.358 2.871 9.005l2.849 4.013a1.596 1.596 0 002.227.377c.719-.51.889-1.507.378-2.227l-2.849-4.013a12.294 12.294 0 01-2.282-7.155V38.34c0-.656.294-1.269.805-1.68a2.146 2.146 0 011.814-.422 2.14 2.14 0 011.686 2.102v19.648c0 2.783 1.022 5.434 2.879 7.495.079.095.161.188.248.281 1.061 1.123 2.308 2.448 3.482 3.696l1.645 1.751.017.016 2.466 2.624a1.597 1.597 0 002.329-2.187c-.029-.031-1.899-2.022-4.034-4.292l-3.663-3.898-.027-.03a2.694 2.694 0 01.052-3.532 2.415 2.415 0 013.145-.4l5.587 3.757a20.34 20.34 0 018.605 12.772l2.617 12.474a1.597 1.597 0 103.124-.657z"
                  />
                  <path
                    d="M21.05 79.219l-.01-.015a1.597 1.597 0 10-2.6 1.856l.01.015a1.593 1.593 0 002.229.373 1.599 1.599 0 00.371-2.229zM88.998 34.169a5.321 5.321 0 00-4.504-1.049 5.314 5.314 0 00-4.189 5.22v19.248a5.622 5.622 0 00-7.125-.729l-5.587 3.757a23.528 23.528 0 00-9.949 14.769l-2.617 12.474a1.599 1.599 0 003.127.656l2.617-12.474a20.342 20.342 0 018.604-12.772l5.588-3.757a2.415 2.415 0 013.145.4 2.695 2.695 0 01.055 3.528l-.029.034-7.697 8.19a1.6 1.6 0 00.07 2.258 1.6 1.6 0 002.259-.071c.021-.023 6.549-6.963 7.609-8.087.086-.092.168-.187.247-.281a11.16 11.16 0 002.879-7.493V38.34a2.14 2.14 0 011.687-2.102 2.143 2.143 0 011.813.422c.512.411.806 1.023.806 1.68v24.767c0 2.578-.789 5.053-2.281 7.155l-12.068 17a1.597 1.597 0 102.605 1.85l12.068-17A15.491 15.491 0 0091 63.106V38.34a5.32 5.32 0 00-2.002-4.171z"
                  />
                  <path
                    d="M70.34 38.615l-2.843-.679v-.51a7.142 7.142 0 003.059-5.858v-3.694c0-3.942-3.208-7.149-7.149-7.149a7.115 7.115 0 00-4.638 1.715c-1.391-3.407-4.739-5.815-8.641-5.815-3.906 0-7.258 2.414-8.646 5.828a7.116 7.116 0 00-4.653-1.728 7.157 7.157 0 00-7.149 7.149v3.694a7.144 7.144 0 003.058 5.857v.51l-2.841.679a7.482 7.482 0 00-5.763 7.302v2.983c0 .882.715 1.597 1.598 1.597h7.34c-.011.195-.019.389-.019.584v5.744c0 .883.715 1.598 1.598 1.598h9.602a1.597 1.597 0 000-3.195h-1.65v-3.301a1.598 1.598 0 00-3.195 0v3.301h-3.159v-4.146a6.613 6.613 0 015.088-6.452l4.383-1.05 2.934 6.674c.256.58.828.954 1.462.954h.001c.633 0 1.207-.374 1.461-.954l2.932-6.664 4.369 1.044a6.612 6.612 0 015.093 6.453v4.142h-3.158v-3.301a1.598 1.598 0 00-3.196 0v3.301h-1.811a1.597 1.597 0 100 3.195h9.762c.883 0 1.598-.715 1.598-1.598v-5.738c0-.198-.009-.395-.021-.589h7.361c.883 0 1.598-.716 1.598-1.598v-2.984a7.487 7.487 0 00-5.765-7.301zm-6.934-14.696a3.959 3.959 0 013.946 3.693H65.13a11.64 11.64 0 01-5.355-1.305 3.963 3.963 0 013.631-2.388zm-3.954 7.416c.002-.078.006-.156.006-.234v-1.423a14.837 14.837 0 005.673 1.129h2.23v.761c0 2.181-1.774 3.954-3.955 3.954s-3.954-1.773-3.954-3.954v-.233zm-15.459-5.379a6.142 6.142 0 016.135-6.135 6.146 6.146 0 016.059 5.16l-2.689-1.58a1.594 1.594 0 00-2.033.352 6.883 6.883 0 01-5.287 2.467h-2.184v-.264zm-7.164-2.037a3.96 3.96 0 013.631 2.388 11.642 11.642 0 01-5.355 1.305h-2.221a3.96 3.96 0 013.945-3.693zm-3.954 6.888h2.229c1.956 0 3.885-.387 5.679-1.131v1.892a3.958 3.958 0 01-3.954 3.955 3.958 3.958 0 01-3.954-3.954v-.762zm7.716 10.716a9.794 9.794 0 00-6.788 5.779h-6.475v-1.386a4.298 4.298 0 013.311-4.194l4.068-.972a1.597 1.597 0 001.227-1.553v-.537c.294.037.593.058.896.058.302 0 .598-.021.89-.058v.456l-.001.071a1.597 1.597 0 001.297 1.572l2.382.571-.807.193zm4.455-2.48a7.427 7.427 0 00-1.279-.431l-2.854-.684v-.498c.516-.36.98-.786 1.385-1.265a9.38 9.38 0 002.748 2.754v.124zm6.937 2.348l-1.869 4.251-1.873-4.262v-1.14a9.377 9.377 0 003.742.006v1.145zm-1.855-4.154a6.142 6.142 0 01-6.135-6.135v-1.687h2.184c2.532 0 4.94-.942 6.787-2.622l3.294 1.935v2.608a6.143 6.143 0 01-6.13 5.901zm5.05 1.811v-.108a9.386 9.386 0 002.771-2.761c.401.474.862.895 1.372 1.251v.498l-2.853.684a7.648 7.648 0 00-1.29.436zm17.729 8.254h-6.496a9.795 9.795 0 00-6.793-5.775l-.802-.192 2.396-.574a1.595 1.595 0 001.305-1.573l-.001-.038v-.49c.293.037.589.058.891.058.303 0 .602-.021.896-.058v.537c0 .739.508 1.382 1.227 1.553l4.068.972a4.299 4.299 0 013.311 4.194v1.386h-.002z"
                  />
                  <path
                    d="M51.237 55.695a1.612 1.612 0 00-1.129-.467c-.422 0-.832.17-1.13.467a1.605 1.605 0 00-.468 1.131c0 .42.169.83.468 1.129a1.61 1.61 0 001.13.469c.42 0 .83-.172 1.129-.469.297-.299.468-.709.468-1.129 0-.422-.171-.832-.468-1.131zM50.106 8c-.882 0-1.598.715-1.598 1.597v2.39a1.599 1.599 0 003.196 0v-2.39c0-.882-.715-1.597-1.598-1.597zM44.223 13.21l-1.676-1.674a1.597 1.597 0 10-2.258 2.259l1.676 1.674a1.595 1.595 0 102.258-2.259zM59.887 11.577a1.598 1.598 0 00-2.259.001l-1.662 1.664a1.598 1.598 0 002.26 2.258l1.663-1.664a1.597 1.597 0 00-.002-2.259z"
                  />
                </svg>
                <h1 class="py-3 font-semibold text-center lg:text-xl">Customer First</h1>
              </div>
              <div class="w-1/2 py-4 md:w-1/4 xl:w-1/2">
                <svg
                  class="block w-24 h-24 mx-auto fill-current color-custom"
                  viewBox="0 0 100 100"
                >
                  <path
                    d="M46.601 64.97a1.642 1.642 0 00-2.321-2.32 1.643 1.643 0 000 2.32c.642.639 1.68.639 2.321 0zM38.834 26.041c0 9.947 8.092 18.041 18.041 18.041 9.947 0 18.041-8.094 18.041-18.041C74.916 16.093 66.822 8 56.875 8c-9.949 0-18.041 8.093-18.041 18.041zm32.802 0c0 8.139-6.622 14.761-14.761 14.761-8.14 0-14.762-6.622-14.762-14.761S48.735 11.28 56.875 11.28c8.139 0 14.761 6.622 14.761 14.761z"
                  />
                  <path
                    d="M26.891 91.51a1.64 1.64 0 002.315.014l7.951-7.834c1.351-1.351 1.762-3.351 1.167-5.089l1.711-1.649a4.889 4.889 0 013.415-1.38h21.803c3.868 0 7.524-1.486 10.296-4.183.114-.111-.866 1.043 14.875-17.77 2.334-2.762 1.984-6.909-.779-9.246-2.748-2.315-6.863-1.982-9.204.731l-9.678 9.947a6.594 6.594 0 00-5.1-2.442H47.375a21.176 21.176 0 00-8.213-1.639c-7.898 0-14.794 3.647-18.495 10.486a4.898 4.898 0 00-4.387 1.359L8.478 70.64a1.64 1.64 0 00-.002 2.313L26.891 91.51zm12.27-37.26c2.512 0 4.94.506 7.22 1.502.208.092.432.139.658.139h18.624c1.778 0 3.281 1.449 3.281 3.28a3.284 3.284 0 01-3.281 3.28H52.281a1.64 1.64 0 000 3.28h13.382a6.568 6.568 0 006.561-6.56c0-.288-.021-.574-.058-.857 9.361-9.624 10.682-10.976 10.738-11.043a3.291 3.291 0 014.624-.391 3.285 3.285 0 01.385 4.628l-14.71 17.587a11.417 11.417 0 01-7.95 3.196H43.45a8.152 8.152 0 00-5.693 2.3l-1.394 1.345-12.848-12.849c3.003-5.634 8.637-8.837 15.646-8.837zM18.602 65.134a1.637 1.637 0 012.031-.23c.284.173-.531-.569 14.206 14.147.655.655.62 1.7.008 2.312l-6.778 6.678-16.116-16.239 6.649-6.668zM54.906 16.201v1.922a4.928 4.928 0 00-3.28 4.639 4.926 4.926 0 004.921 4.92 1.64 1.64 0 010 3.28c-.701 0-1.458-.44-2.13-1.241a1.641 1.641 0 00-2.512 2.111c.878 1.042 1.908 1.77 3.001 2.136v1.914a1.64 1.64 0 103.28 0V33.96a4.929 4.929 0 003.281-4.638 4.925 4.925 0 00-4.92-4.92 1.642 1.642 0 01-1.641-1.64c0-.904.735-1.641 1.641-1.641.58 0 1.193.296 1.773.857a1.64 1.64 0 102.281-2.357c-.833-.805-1.666-1.261-2.416-1.51v-1.91a1.64 1.64 0 10-3.279 0z"
                  />
                </svg>
                <h1 class="py-3 font-semibold text-center lg:text-xl">Affordable & Effectivee</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end why chooose us -->

    <!-- Testimonial -->
    <div class="py-8 bg-red-custom">
      <div class="container">
        <div class="max-w-sm mx-auto md:max-w-full">
          <h1
            class="pb-6 text-xl font-bold text-center text-white md:text-2xl lg:text-3xl"
          >Happy Customer Reviews</h1>
          <carousel 
            :autoplay="true"
            :responsive="{0:{items:1,nav:false},600:{items:2,nav:false},900:{items:3,nav:false},1200:{items:4,nav:false}}"
          >
            <div>
              <div class="mx-3 bg-white rounded-lg md:h-full equalizer">
                <p class="p-8 text-grey-500">
                  "I had a terrible bed bug infestation, and after all the remedies I found online, I still couldn’t get rid of them. I called My Pest, and they came the same day to assess the situation. They were able to treat my house and eliminate the bed bugs completely. I'm so grateful for their fast and effective service!"
                </p>
                <h1 class="pb-8 mt-auto font-semibold text-center text-md">Mr SK Lim, Circuit Road</h1>
              </div>
            </div>
            <div>
              <div class="mx-3 bg-white rounded-lg md:h-full equalizer">
                <p class="p-8 text-grey-500">
                  “I had bed bug problem in my rented apartment. Landlord say that it is not his issue, I will have to settle myself. I found and engage My Pest as they are very assuring. I shared with them that I am looking for a pest control company that can resolve it in the fastest and not so costly way. There are prompt and pricing reasonable. Very happy with their service.”
                </p>
                <h1 class="pb-8 mt-auto font-semibold text-center text-md">Allan Chua, Serangoon</h1>
              </div>
            </div>
            <div>
              <div class="mx-3 bg-white rounded-lg md:h-full equalizer">
                <p class="p-8 text-grey-500">
                  “My Pest was able to get rid of my bed bug issue in one visit. Which is the reason for this review. We got a kid sleeping with us, and we really just want to get rid of the issue as soon as possible. My Pest is quick and professional. Will recommend, thank you!”
                </p>
                <h1 class="pb-8 mt-auto font-semibold text-center text-md">Hannah Lim, Clementi</h1>
              </div>
            </div>
            <div>
              <div class="mx-3 bg-white rounded-lg md:h-full equalizer">
                <p class="p-8 text-grey-500">
                  “Bed bug problem is so devastating! First time facing bed bug issue, was very worry how fast it will spread, and how serious it will get. Is very happy with My Pest as they are able to come over the very same day. Within the visit they provided us with the solution. And problem all solve! Highly Recommend!”
                </p>
                <h1 class="pb-8 mt-auto font-semibold text-center text-md">Nicole Tan, Jurong</h1>
              </div>
            </div>
            <div>
              <div class="mx-3 bg-white rounded-lg md:h-full equalizer">
                <p class="p-8 text-grey-500">
                  “Staying in a high-floor HDB, it never occurs to me that I will face with termite issue one day. I always thought that it is a pest issue that only landed home owners will face. My door frames and cabinets are damage. I found My Pest to rectify the issue. I find them professional and efficient. It did not long them long, and after 2 visits, termite infestation is resolve. Will recommend them”
                </p>
                <h1 class="pb-8 mt-auto font-semibold text-center text-md">Raymond Sim, Punggol</h1>
              </div>
            </div>
          </carousel>
        </div>
      </div>
    </div>
    <!-- End Testimonial -->

    <!-- FAQ -->
    <div id="faqs" class="pb-8 text-white bg-black section">
      <div class="container">
        <div class="py-4 text-center color-custom">
          <h1 class="text-xl">Frequently Asked</h1>
          <h1 class="pb-3 text-2xl font-bold md:text-2xl lg:text-3xl">Questions</h1>
        </div>
        <div class="mx-auto">
          <ListFaq />
        </div>
      </div>
    </div>
    <!-- End FAQ -->

    <!-- about us -->
    <div class="py-8 bg-red-custom">
      <div class="container">
        <div class="md:flex md:flex-wrap">
          <div class="w-full text-center">
            <h1 class="text-xl text-white">About Us</h1>
            <h1
              class="pb-3 text-2xl font-bold text-white md:text-2xl lg:text-3xl"
            >My Pest Pte Ltd</h1>

            <p class="py-3 text-sm font-normal text-white lg:text-base">
              At My Pest, we understand how disruptive and stressful pest infestations can be, whether they're in your home or business. That's why we're dedicated to providing fast, effective, and long-lasting pest control solutions to our clients.
            </p>
            <p class="py-3 text-sm font-normal text-white lg:text-base">
              With over 10 years of experience in the pest control industry, we have the expertise and knowledge to tackle any pest problem, big or small. Our team of certified technicians uses the latest technologies and products available to provide safe and environmentally friendly pest control services.
            </p>
            <p class="py-3 text-sm font-normal text-white lg:text-base">
              We offer a wide range of pest control services, including termite control, bed bug treatments, rodent control, and more. Whether you're dealing with a one-time pest problem or need ongoing pest control services, we have the experience and expertise to help. 
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- end about us -->

    <!-- footer -->
    <SiteFooter />
    <!-- end footer -->
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import SiteHeader from "@/components/SiteHeader.vue";
import SiteFooter from "@/components/SiteFooter.vue";
import Copyright from "@/components/Copyright.vue";
import WaBtn from "@/components/WaBtn.vue";
import carousel from "vue-owl-carousel";
import Blink from "vue-blink";
import ListFaq from "@/components/ListFaq";

export default {
  name: "Home",
  components: {
    SiteHeader,
    SiteFooter,
    Copyright,
    WaBtn,
    carousel,
    Blink,
    ListFaq
  },
  data() {
    return {
      choose: [
        { p: "Immediate identification of problems" },
        { p: "Thorough site inspection" },
        { p: "Advanced chemical & equipment" },
        { p: "Customised treatment plan" },
        { p: "Trained & experience professional" },
        { p: "100% safe treatment" }
      ],
      others: [
        { image: "/images/battery-amaron.jpg", alt: "AMARON Hi-Life" },
        { image: "/images/battery-camel.jpg", alt: "CAMEL Car battery" },
        { image: "/images/battery-varta.jpg", alt: "VARTA Sliver Series" },

        // { image: "/images/battery-entrac-plus.jpg", alt: "Emtrac Plus" },
        // { image: "/images/battery-incoe.jpg", alt: "Incoe Premium" },
        { image: "/images/battery-motolite.jpg", alt: "MOTOLITE Heavy Duty" }
        // { image: "/images/battery-gepro.jpg", alt: "Gepro Japan" }
      ],
      gallerys: [
        { image: "/images/car/car-1.jpg" },
        { image: "/images/car/car-2.jpg" },
        { image: "/images/car/car-3.jpg" },
        { image: "/images/car/car-4.jpg" },
        { image: "/images/car/car-5.jpg" },
        { image: "/images/car/car-8.jpg" },
        { image: "/images/car/car-9.jpg" },
        { image: "/images/car/car-10.jpg" },
        { image: "/images/car/car-11.jpg" }
      ]
    };
  },
};
</script>


<style>
.owl-carousel .owl-stage {
  display: flex;
  align-items: stretch;
}
p {
  font-family: "Roboto", sans-serif !important;
}
.bg-red-custom {
  background-color:#ce3243;
}
.color-custom {
  color: #ce3243;
}
.blink-me {
  animation: blink 1.3s linear infinite;
}
.accordion__title-text, .accordion__value {
  color: white !important;
}
@media (min-width: 1024px) {
  .equalizer {
    min-height: 456px;
  }
}
</style>
